/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavDropdownContent_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNavItem_navigationModule$ref: FragmentReference;
export type SiteNavItem_navigationModule = {|
  +imageLink: ?string,
  +$fragmentRefs: SiteNavDropdownContent_navigationModule$ref,
  +$refType: SiteNavItem_navigationModule$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SiteNavItem_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownContent_navigationModule",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageLink",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ac683800b48fd183cc8e577225bf54af';
module.exports = node;
